import { connect } from 'react-redux'
import OptOutModal, { OptOutModalDispatchProps, OptOutModalStateProps } from 'components/features/pfm/OptOutModal/OptOutModal'
import { toggleSettingsModalActionCreator } from 'actions/settingsActions'
import { State } from 'interfaces/state'

const mapStateToProps = (state: State): OptOutModalStateProps => {
  const { modal } = state.app.settings

  return {
    modalShown: Boolean(modal && modal.type === 'opt-out'),
  }
}

const mapDispatchToProps: OptOutModalDispatchProps = {
  hideModal: () => toggleSettingsModalActionCreator(null),
}

const OptOutModalContainer = connect(mapStateToProps, mapDispatchToProps)(OptOutModal)
export default OptOutModalContainer
